import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProviderPageLayout from '../../components/ProviderPageLayout';

const ProviderPrivacy = () => {
  const navigate = useNavigate();

  return (
    <ProviderPageLayout variant="auth" bare>
      <div className="provider-legal">
        <div className="provider-legal-header">
          <p className="provider-eyebrow">Legal</p>
          <h1 className="provider-title">Privacy Policy</h1>
          <p className="provider-legal-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="provider-legal-toc">
          <p className="provider-legal-toc-title">Contents</p>
          <ol>
            <li>Information we collect</li>
            <li>How we use information</li>
            <li>Payment data</li>
            <li>Sharing &amp; disclosure</li>
            <li>Data retention</li>
            <li>Security</li>
            <li>Your rights</li>
            <li>Contact</li>
          </ol>
        </div>

        <div className="provider-legal-body">
          <p>
            This Privacy Policy explains how RetechSys LLC (&quot;ReTechSys,&quot; &quot;we,&quot;
            &quot;us&quot;) collects, uses, and protects information when you use the Provider Portal
            (the &quot;Service&quot;).
          </p>

          <h2>1. Information We Collect</h2>
          <p>We collect the following categories of information:</p>
          <ul>
            <li>
              <strong>Account information</strong> — your name, email address, and business (store)
              details you provide at signup.
            </li>
            <li>
              <strong>Store &amp; device information</strong> — store name, location, and the device
              identifier used to link your account.
            </li>
            <li>
              <strong>Usage data</strong> — transactions processed through your account, used for
              reporting and billing.
            </li>
            <li>
              <strong>Technical data</strong> — log data, browser type, and cookies necessary to
              operate the Service.
            </li>
          </ul>

          <h2>2. How We Use Information</h2>
          <ul>
            <li>To provide, maintain, and secure the Service.</li>
            <li>To calculate usage and issue monthly invoices.</li>
            <li>To communicate with you about your account and support requests.</li>
            <li>To comply with legal and regulatory obligations.</li>
          </ul>

          <h2>3. Payment Data</h2>
          <p>
            Payment card details are collected and processed directly by our payment processor,
            <strong> Stripe</strong>, and are never stored on ReTechSys servers. Your billing address
            is collected by Stripe during payment setup. Stripe&apos;s handling of your data is
            governed by its own privacy policy.
          </p>

          <h2>4. Sharing &amp; Disclosure</h2>
          <p>
            We do not sell your personal information. We share data only with service providers who
            help us operate the Service (such as Stripe for payments and AWS for hosting), or when
            required by law.
          </p>

          <h2>5. Data Retention</h2>
          <p>
            We retain account and usage data for as long as your account is active and as needed to
            comply with legal obligations, resolve disputes, and enforce agreements.
          </p>

          <h2>6. Security</h2>
          <p>
            We use industry-standard safeguards to protect your information. Personal identifiers are
            stored in managed identity infrastructure, and payment data is handled by PCI-compliant
            processors. No method of transmission is completely secure, but we work to protect your
            data.
          </p>

          <h2>7. Your Rights</h2>
          <p>
            Depending on your jurisdiction, you may have the right to access, correct, or delete your
            personal information. To exercise these rights, contact us at the address below.
          </p>

          <h2>8. Contact</h2>
          <p>
            Questions about privacy? Email{' '}
            <a href="mailto:support@retechsys.ai">support@retechsys.ai</a>.
          </p>
        </div>

        <div style={{ marginTop: 40 }}>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="provider-btn provider-btn--secondary provider-btn--inline"
          >
            ← Back
          </button>
        </div>
      </div>
    </ProviderPageLayout>
  );
};

export default ProviderPrivacy;
